import moment from "moment";
import { FLIGHT_STATUS_VALUES } from "constants/variables";

const isDepartureTimeGreaterThanCurrentTime = (departureTime) => {
  const currentTime = moment();
  return moment(departureTime).isAfter(currentTime);
};

export const showDepartureText = (status: string, options: { departureTime?: string } = {}) => {
  if (status === FLIGHT_STATUS_VALUES.NOT_DEPARTED) {
    return "Estimated Departure";
  }
  if (status === FLIGHT_STATUS_VALUES.DEPARTED || status === FLIGHT_STATUS_VALUES.ARRIVED || status === FLIGHT_STATUS_VALUES.EARLY) {
    return "Departed";
  }
  if (status === FLIGHT_STATUS_VALUES.YET_TO_DEPART || status === FLIGHT_STATUS_VALUES.DELAYED) {
    return "Scheduled Departure";
  }
  if (status === FLIGHT_STATUS_VALUES.ONTIME) {
    const { departureTime } = options;
    if (isDepartureTimeGreaterThanCurrentTime(departureTime)) {
      return "Scheduled Departure";
    }
    return "Departed";
  }
  return "Departed";
};
